/* eslint-disable jira/filename-case */
export const TOP_NAV = 'TOP_NAV' as const;
export const SIDEBAR = 'SIDEBAR' as const;
